// Country Flag Service - Centralized flag management
import { useState } from 'react';

// Get country flag emoji by country code
export const getCountryFlagEmoji = (countryCode) => {
  const flags = {
    'US': '🇺🇸', 'GB': '🇬🇧', 'DE': '🇩🇪', 'FR': '🇫🇷', 'IT': '🇮🇹',
    'ES': '🇪🇸', 'CA': '🇨🇦', 'AU': '🇦🇺', 'JP': '🇯🇵', 'KR': '🇰🇷',
    'CN': '🇨🇳', 'IN': '🇮🇳', 'BR': '🇧🇷', 'MX': '🇲🇽', 'AR': '🇦🇷',
    'CL': '🇨🇱', 'CO': '🇨🇴', 'PE': '🇵🇪', 'VE': '🇻🇪', 'RU': '🇷🇺',
    'PL': '🇵🇱', 'NL': '🇳🇱', 'BE': '🇧🇪', 'CH': '🇨🇭', 'AT': '🇦🇹',
    'SE': '🇸🇪', 'NO': '🇳🇴', 'DK': '🇩🇰', 'FI': '🇫🇮', 'PT': '🇵🇹',
    'GR': '🇬🇷', 'TR': '🇹🇷', 'ZA': '🇿🇦', 'EG': '🇪🇬', 'NG': '🇳🇬',
    'KE': '🇰🇪', 'MA': '🇲🇦', 'TH': '🇹🇭', 'VN': '🇻🇳', 'MY': '🇲🇾',
    'SG': '🇸🇬', 'ID': '🇮🇩', 'PH': '🇵🇭', 'NZ': '🇳🇿', 'IE': '🇮🇪',
    'IL': '🇮🇱', 'AE': '🇦🇪', 'SA': '🇸🇦', 'PK': '🇵🇰', 'BD': '🇧🇩',
    'LK': '🇱🇰', 'MM': '🇲🇲', 'KH': '🇰🇭', 'LA': '🇱🇦', 'UY': '🇺🇾',
    'PY': '🇵🇾', 'BO': '🇧🇴', 'EC': '🇪🇨', 'CZ': '🇨🇿', 'SK': '🇸🇰',
    'HU': '🇭🇺', 'RO': '🇷🇴', 'BG': '🇧🇬', 'HR': '🇭🇷', 'SI': '🇸🇮',
    'LT': '🇱🇹', 'LV': '🇱🇻', 'EE': '🇪🇪', 'IS': '🇮🇸', 'LU': '🇱🇺',
    'MT': '🇲🇹', 'CY': '🇨🇾', 'UA': '🇺🇦', 'BY': '🇧🇾', 'MD': '🇲🇩',
    'BA': '🇧🇦', 'RS': '🇷🇸', 'ME': '🇲🇪', 'MK': '🇲🇰', 'AL': '🇦🇱',
    'XK': '🇽🇰', 'AM': '🇦🇲', 'AZ': '🇦🇿', 'GE': '🇬🇪', 'KZ': '🇰🇿',
    'UZ': '🇺🇿', 'TM': '🇹🇲', 'KG': '🇰🇬', 'TJ': '🇹🇯', 'AF': '🇦🇫',
    'IR': '🇮🇷', 'IQ': '🇮🇶', 'SY': '🇸🇾', 'LB': '🇱🇧', 'JO': '🇯🇴',
    'PS': '🇵🇸', 'YE': '🇾🇪', 'OM': '🇴🇲', 'QA': '🇶🇦', 'BH': '🇧🇭',
    'KW': '🇰🇼', 'MN': '🇲🇳', 'NP': '🇳🇵', 'BT': '🇧🇹', 'MV': '🇲🇻',
    'XX': '🌍' // Default for unknown countries
  };
  return flags[countryCode] || '🌍';
};

// Get country full name from code
export const getCountryName = (countryCode) => {
  const countryNames = {
    'US': 'United States', 'GB': 'United Kingdom', 'DE': 'Germany', 'FR': 'France', 'IT': 'Italy',
    'ES': 'Spain', 'CA': 'Canada', 'AU': 'Australia', 'JP': 'Japan', 'KR': 'South Korea',
    'CN': 'China', 'IN': 'India', 'BR': 'Brazil', 'MX': 'Mexico', 'AR': 'Argentina',
    'CL': 'Chile', 'CO': 'Colombia', 'PE': 'Peru', 'VE': 'Venezuela', 'RU': 'Russia',
    'PL': 'Poland', 'NL': 'Netherlands', 'BE': 'Belgium', 'CH': 'Switzerland', 'AT': 'Austria',
    'SE': 'Sweden', 'NO': 'Norway', 'DK': 'Denmark', 'FI': 'Finland', 'PT': 'Portugal',
    'GR': 'Greece', 'TR': 'Turkey', 'ZA': 'South Africa', 'EG': 'Egypt', 'NG': 'Nigeria',
    'KE': 'Kenya', 'MA': 'Morocco', 'TH': 'Thailand', 'VN': 'Vietnam', 'MY': 'Malaysia',
    'SG': 'Singapore', 'ID': 'Indonesia', 'PH': 'Philippines', 'NZ': 'New Zealand', 'IE': 'Ireland',
    'IL': 'Israel', 'AE': 'UAE', 'SA': 'Saudi Arabia', 'PK': 'Pakistan', 'BD': 'Bangladesh',
    'LK': 'Sri Lanka', 'MM': 'Myanmar', 'KH': 'Cambodia', 'LA': 'Laos', 'UY': 'Uruguay',
    'PY': 'Paraguay', 'BO': 'Bolivia', 'EC': 'Ecuador', 'CZ': 'Czech Republic', 'SK': 'Slovakia',
    'HU': 'Hungary', 'RO': 'Romania', 'BG': 'Bulgaria', 'HR': 'Croatia', 'SI': 'Slovenia',
    'LT': 'Lithuania', 'LV': 'Latvia', 'EE': 'Estonia', 'IS': 'Iceland', 'LU': 'Luxembourg',
    'MT': 'Malta', 'CY': 'Cyprus', 'UA': 'Ukraine', 'BY': 'Belarus', 'MD': 'Moldova'
  };
  return countryNames[countryCode] || countryCode;
};

// Get flag image URL from flagcdn API
export const getFlagImageUrl = (countryCode, size = '24x18') => {
  return `https://flagcdn.com/${size}/${countryCode.toLowerCase()}.png`;
};

// Enhanced flag component using flag API with fallback
export const CountryFlag = ({ countryCode, className = "w-6 h-4" }) => {
  const [imageError, setImageError] = useState(false);

  if (imageError) {
    return (
      <span className="text-lg leading-none" title={`${countryCode} flag`}>
        {getCountryFlagEmoji(countryCode)}
      </span>
    );
  }

  return (
    <img
      src={getFlagImageUrl(countryCode)}
      alt={`${countryCode} flag`}
      className={`${className} object-cover rounded-sm border border-gray-200 shadow-sm`}
      onError={() => setImageError(true)}
      title={`${countryCode} flag`}
      loading="lazy"
    />
  );
};